.content {
  .text {
    margin-top: 8px;
  }
}

.image {
  width: 100%;
}
